module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-7.3bda585a.png";